import { render, staticRenderFns } from "./SlidingBayDescription.vue?vue&type=template&id=69e15804&scoped=true"
import script from "./SlidingBayDescription.vue?vue&type=script&lang=ts"
export * from "./SlidingBayDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e15804",
  null
  
)

export default component.exports